<!--
 * @Author: your name
 * @Date: 2021-11-15 15:42:40
 * @LastEditTime: 2021-11-22 14:19:53
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /ark-student-wap/src/pages/arkHome/components/association.vue
-->
<!--  -->
<template>
  <div class="">
    <van-popup v-model="show" position="bottom" duration="0.18" round @click-overlay="close">
      <div class="title">
        <div class="title-left">
          <img src="@/assets/img/loginImg/group-step.png" alt="" />
        </div>
        <div class="title-txt">
          <h1>课程预约成功</h1>
          <h2>{{ communityInfo.text }}</h2>
        </div>
      </div>
      <div class="group-content">
        <img v-if="communityInfo.accountType" class="qrocde" :src="communityInfo.qrcode" alt="" />
        <div v-else class="official">
          <div>
            <img src="@/assets/img/arkHome/gift1.png" alt="" />
            <p>直播提醒</p>
          </div>
          <div>
            <img src="@/assets/img/arkHome/gift2.png" alt="" />
            <p>学习资讯</p>
          </div>
          <div>
            <img src="@/assets/img/arkHome/gift3.png" alt="" />
            <p>直播福利</p>
          </div>
        </div>
        <p>
          {{
            communityInfo.groupEntryMode === 1 && communityInfo.platform === 2
              ? '请截图保存二维码到微信添加'
              : '点击下方按钮即可添加'
          }}
        </p>
        <!-- 请截图保存二维码到微信添加 -->
      </div>
      <button class="btn" @click="openPage">
        {{ btnStatus() }}
      </button>
    </van-popup>
    <RemindBox v-if="isRemindBox" @closeRemindBox="closeRemindBox" />
  </div>
</template>

<script>
import { reqCourseCommunitySku } from '@/api/courseDetail/community/community';
import RemindBox from '@/components/remindBox/index.vue';

// import { copyTool } from '@/utils/tools';

export default {
  components: {
    RemindBox,
  },
  data() {
    return {
      show: false,
      isRemindBox: false,
      communityInfo: {
        text: '关注官方公众号，享更多福利',
      },
    };
  },
  props: {
    courseInfo: {
      type: Object,
      default: () => {},
    },
  },
  computed: {},
  watch: {
  },
  created() {},
  mounted() {
    this.getCourseCommunitySku();
  },
  methods: {
    showRemindBox() {
      // 打开开播提醒
      this.isRemindBox = true;
    },
    closeRemindBox() {
      // 关闭开播提醒
      this.isRemindBox = false;
    },
    async getCourseCommunitySku() {
      this.show = true;
      const { productId, productSkuSimpleVOS } = this.courseInfo;
      const request = await reqCourseCommunitySku(productId, productSkuSimpleVOS[0].productSkuId);
      if (request?.code === 0 && request?.data) {
        const {
          platform, accountType, qrcode, linkUrl, groupEntryMode,
        } = request.data;
        let text = '';
        if (platform === 1) {
          // QQ
          text = accountType === 1 ? '加入学习群，领取更多学习资料' : '添加老师QQ，享受课程服务';
        } else {
          // 微信
          text = accountType === 2 ? '添加老师微信，享受课程服务' : '加入学习群，领取更多学习资料';
        }
        Object.assign(this.communityInfo, {
          text,
          qrcode,
          accountType,
          platform,
          linkUrl,
          groupEntryMode,
        });
      }
    },
    btnStatus() {
      const { accountType } = this.communityInfo;
      let text = '';
      if (accountType === 1) {
        text = '立即加入';
      } else if (accountType === 2) {
        text = '立即添加';
      } else {
        text = '立即关注';
      }
      return text;
    },
    close() {
      this.$emit('closeGroup', true);
      this.show = false;
    },
    openPage() {
      const { platform, linkUrl, groupEntryMode } = this.communityInfo;
      let url = linkUrl;
      //   微信 2 微伴有链接   1 无链接需要截图保存并打开微信
      if (groupEntryMode === 1 && platform === 2) {
        url = 'weixin://';
      }
      // 未配置社群
      if (!platform) {
        this.showRemindBox();
        // url = 'weixin://dl/business/?t=ZtXZb3rT6hn';
      }
      window.location.href = url;
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .van-popup--round {
  border-radius: 18px;
}
.title {
  display: flex;
  justify-content: flex-start;
  padding: 62px 47px 37px 47px;
  .title-left {
    > img {
      width: 43px;
      height: 170px;
    }
  }
  .title-txt {
    padding: 8px 0 0 33px;
    h1,
    h2 {
      color: #333;
      font-weight: 600;
      font-size: 33px;
    }
    h1 {
      padding-bottom: 90px;
    }
  }
}
.group-content {
  .qrocde {
    display: block;
    width: 290px;
    height: 290px;
    margin: 0 auto;
  }
  .official {
    display: flex;
    justify-content: space-between;
    padding: 20px 85px 50px 85px;
    img {
      width: 141px;
      height: 141px;
    }
    p {
      padding-top: 20px;
      color: #333;
      font-weight: 400;
      font-size: 29px;
    }
  }
  > p {
    padding: 29px 0 29px 0;
    color: #787878;
    font-weight: 400;
    font-size: 25px;
    text-align: center;
  }
}
.btn {
  display: block;
  width: 634px;
  height: 91px;
  margin: 0 auto 40px;
  color: #fff;
  font-weight: 500;
  font-size: 36px;
  background: #ff6c02;
  border-radius: 45px;
}
</style>
